import { ApplicationRef, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { debounce } from 'cypress/types/lodash';
import { concat, debounceTime, filter, first, interval, tap } from 'rxjs';
import { ToastService } from './toast.service';


@Injectable({
  providedIn: 'root'
})
export class VersionUpdatesService {

  constructor(appRef: ApplicationRef,
    private swUpdate: SwUpdate, private router: Router,
    toasts: ToastService) {
    console.log('Constructor:VersionUpdatesService');
    if (!swUpdate.isEnabled) {
      console.warn('rr Service Worker Update Service is not enabled!!');
      return;
    }
    this.router.events
      .pipe(
        filter(evt => evt instanceof NavigationEnd),
        debounceTime(120 * 1000),
        tap(x=>{ this.checkForUpdate();})
      )
      .subscribe();


    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const regularUpdateCheckOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
    //const everyThirtySeconds$ = interval(30 * 1000);
    //const regularUpdateCheckOnceAppIsStable$ = concat(appIsStable$, everyThirtySeconds$);


    regularUpdateCheckOnceAppIsStable$.subscribe(async () => {
      await this.checkForUpdate()
    });
    swUpdate
      .versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(evt => {
        document.location.reload();
        //if (promptUser(evt)) {
        // Reload the page to update to the latest version.
        //   document.location.reload();
        // }
      });

    swUpdate.versionUpdates.subscribe(evt => {
      console.log(evt);
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });
    swUpdate.unrecoverable.subscribe(event => {
      console.log('Unrecoverable event detected forcing reload');
      window.location.reload();
    });

  }
  private async checkForUpdate(){
    try {
      const updateFound = await this.swUpdate.checkForUpdate();
      console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
    } catch (err) {
      console.error('Failed to check for updates:', err);
    }
  }
  public doNothing() { }
}
